
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NodePolicies"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CoreNode"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlogPolicies"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TkbPolicies"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ForumPolicies"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoardPolicies"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategoryPolicies"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupHubPolicies"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommunityPolicies"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaPolicies"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OccasionPolicies"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesforceCasePolicies"},"directives":[]}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  doc.definitions = doc.definitions.concat(unique(require("../BlogPolicies.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../TkbPolicies.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../ForumPolicies.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../IdeaPolicies.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../BoardPolicies.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../CategoryPolicies.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../../community/CommunityPolicies/CommunityPolicies.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../GroupHubPolicies.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../OccasionPolicies.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../SalesforceCasePolicies.fragment.graphql").definitions));


    module.exports = doc
  
